import { useQuery } from "@tanstack/react-query";
import { getQueryTypes } from "../../service/query/auth";

export const useGetQueryTypes = () => {
  return useQuery({
    queryKey: ["queryTypes"],
    queryFn: () => getQueryTypes(),
  });
};